'use client'

import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Search } from 'lucide-react'
import type { ConversationFilters } from '@/hooks/agents/messaging/use-conversations'
import type { ChannelType } from '@/lib/agents/messaging/types'
import { CHANNEL_LABELS } from '@/lib/agents/messaging/types'
import { useTranslations } from "next-intl"


interface InboxFiltersProps {
  filters: ConversationFilters
  onChange: (filters: ConversationFilters) => void
  /** Only show channels that have conversations */
  availableChannels?: string[]
}

export function InboxFilters({ filters, onChange, availableChannels = [] }: InboxFiltersProps) {
  const tUi = useTranslations("Messaging.AgentsMessagingInboxInboxFilters")

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b flex-shrink-0">
      <div className="relative flex-1">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
        <Input
          placeholder={tUi("searchContacts")}
          value={filters.search || ''}
          onChange={(e) => onChange({ ...filters, search: e.target.value || undefined })}
          className="pl-8 h-8 text-sm"
        />
      </div>
      {availableChannels.length > 1 && (
        <Select
          value={filters.channel_type || 'all'}
          onValueChange={(v) =>
            onChange({ ...filters, channel_type: v === 'all' ? undefined : (v as ChannelType) })
          }
        >
          <SelectTrigger className="w-[120px] h-8 text-xs">
            <SelectValue placeholder={tUi("channel")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all"><span key={tUi("allChannels")}>{tUi("allChannels")}</span></SelectItem>
            {availableChannels.map((ch) => (
              <SelectItem key={ch} value={ch}>
                {CHANNEL_LABELS[ch as ChannelType] || ch}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  )
}
